// extracted by mini-css-extract-plugin
export var action_btn = "mix_colors-module--action_btn--183bf";
export var actions_bar = "mix_colors-module--actions_bar--4d6c6";
export var color_formats_list = "mix_colors-module--color_formats_list--853a7";
export var color_picker_wrapper = "mix_colors-module--color_picker_wrapper--fbadc";
export var color_scale_wrapper = "mix_colors-module--color_scale_wrapper--add36";
export var format_label = "mix_colors-module--format_label--5cceb";
export var format_value = "mix_colors-module--format_value--e106b";
export var gradient_bar = "mix_colors-module--gradient_bar--7c66f";
export var input_hex_color = "mix_colors-module--input_hex_color--41152";
export var mix_color_picker_wrapper = "mix_colors-module--mix_color_picker_wrapper--5643e";
export var mix_color_result = "mix_colors-module--mix_color_result--c87c1";
export var mix_color_title = "mix_colors-module--mix_color_title--4e3ed";
export var mix_colors_wrapper = "mix_colors-module--mix_colors_wrapper--1c1fd";
export var mix_controls = "mix_colors-module--mix_controls--e462a";
export var mix_mode_select = "mix_colors-module--mix_mode_select--d4377";
export var mix_tool_wrapper = "mix_colors-module--mix_tool_wrapper--a2f6e";
export var react_colorful = "mix_colors-module--react_colorful--8943c";
export var result_hex = "mix_colors-module--result_hex--a9bcb";
export var scale_color = "mix_colors-module--scale_color--edc73";
export var scale_preview = "mix_colors-module--scale_preview--b5d70";
export var scale_section = "mix_colors-module--scale_section--c8252";
export var section_card = "mix_colors-module--section_card--c95ab";
export var subtitle = "mix_colors-module--subtitle--0e0c5";
export var swap_btn = "mix_colors-module--swap_btn--78b44";
export var toast = "mix_colors-module--toast--8cda3";
export var toastIn = "mix_colors-module--toastIn--b565c";